/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api";

export const fetchAdmin = createAsyncThunk("user/fetchAdmin", async () => {
  const response = await api.get("/v1/admin/me");
  return response?.data;
});

const adminSlice = createSlice({
  name: "admin",
  initialState: {
    admin: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearAdmin(state) {
      state.admin = null;
      state.error = null;
    },
    updateAdminLanguage(state, action) {
      if (state.admin) {
        state.admin.language_preference = action.payload;
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdmin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdmin.fulfilled, (state, action) => {
        state.admin = action.payload;
        state.error = null;
        state.loading = false;
      })
      .addCase(fetchAdmin.rejected, (state, action) => {
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export const { clearAdmin, updateAdminLanguage } = adminSlice.actions;
export default adminSlice.reducer;
